<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="bigTotal"
            :loading="loading" :total="total"
            helper="6bWGJZoZpYumI82K8m6wme"
            :label="'Accès Externe'">
      <div class="column is-paddingless is-border-left" slot="right-content">
        <a @click="newAccess" class="page-header-btn is-small">
          <span class="icon"><i class="fas fa-plus-square"></i></span>
          <span>Nouvel Accès</span>
        </a>
      </div>
      <div class="column is-paddingless is-border-left" slot="right-content">
        <a @click="loadItems()" class="page-header-btn is-small is-square">
          <span class="icon"><i class="fas fa-sync"></i></span>
        </a>
      </div>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="columns is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-12 is-paddingless">
        <div class="is-border is-radius-large">
          <div class="">
            <table v-show="!loading && items.length" class="table is-fullwidth is-marginless-bottom is-last-fixed-small">
              <thead>
                <tr class="is-size-6">
                  <th>
                    <sortable @sort="sort('created_on', $event)" :sort="sortBy.created_on" label="Date de création"></sortable>
                  </th>
                  <th>
                    <sortable @sort="sort('login', $event)" :sort="sortBy.login" label="Login"></sortable>
                  </th>
                  <th>Mot de Passe</th>
                  <th>Niveau d'accès</th>
                  <th>Début de validité</th>
                  <th>Fin de validité</th>
                  <th class="has-text-centered" width="70px">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="access in items" :key="access.pk" class="is-size-6">
                  <td>{{access.created_on | prettyDate}}</td>
                  <td>{{access.login}}</td>
                  <td>{{access.password}}</td>
                  <td>{{access.scope}}<span v-if="access.scope === 'PROGRAM'">: {{access.program_name}}</span></td>
                  <td><span v-if="access.start_date">{{access.start_date | prettyDate}}</span><span v-else>--</span></td>
                  <td><span v-if="access.end_date">{{access.end_date | prettyDate}}</span><span v-else>--</span></td>
                  <td class="has-text-centered actions">
                    <div class="dropdown is-hoverable is-right">
                      <div class="dropdown-trigger">
                        <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                          <i class="fas fa-ellipsis-v"></i>
                        </button>
                      </div>
                      <div class="dropdown-menu" id="dropdown-menu" role="menu">
                        <div class="dropdown-content has-text-left">
                          <!--<a @click.prevent.stop="currentAccessEdit = access" class="dropdown-item">
                            <span class="icon"><i class="fal fa-edit"></i></span> Editer
                          </a> -->
                          <a @click.prevent.stop="deleteItem(access.pk)" class="dropdown-item">
                            <span class="icon"><i class="fal fal fa-trash"></i></span>Supprimer
                          </a>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="empty empty--row" v-for="n in items.length < 8 ? 8 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>
              </tbody>
            </table>
            <div class="is-border-top" v-if="totalPage > 1 && nextPage">
              <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
                <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
                <span class="is-size-6">Afficher la suite</span>
              </a>
              <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
            </div>
            <div v-show="!loading && !items.length">
              <div class="columns">
                <div class="column">
                  <h2 class="title is-3 has-text-weight-bold">Aucun accès</h2>
                  <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
                    class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GenericList, Filter, Sort } from '../../mixins'

  export default {
    name: 'ExternalAccessList',
    mixins: [GenericList, Filter, Sort],
    props: {},
    data () {
      return {
        loadDocuments: this.loadItems,
        buttonList: [],
        service: this.$api.externalAccessService,
        infiniteLoaderEnabled: true
      }
    },
    computed: {},
    methods: {
      newAccess () {
        let query = {}
        if (this.$route.query.program) {
          query.program = this.$route.query.program
        }
        this.$router.push({name: 'ExternalAccessCreate', query})
      }
    },
    created () {
      this.loadItems()
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/external-access/ExternalAccessList.vue